import { boolean, enums, nullable, object } from "superstruct";

import { CAN_LEAVE_REVIEW_MESSAGE_KEY } from "../constants";

const CanLeaveReviewSchema = object({
    canLeaveReview: boolean(),
    messageKey: nullable(
        enums([...Object.values(CAN_LEAVE_REVIEW_MESSAGE_KEY)])
    ),
});

export default CanLeaveReviewSchema;
